<template>
  <el-button
    type="primary"
    @click="$refs['fileInput'].click()"
    icon="el-icon-upload"
    data-qa="import-from-csv-button"
  >
    {{ $t('Lists_ListItemsList_Import') }}
    <input
      :ref="'fileInput'"
      type="file"
      style="display: none"
      accept=".csv"
      @change="importFile($event)"
    />
  </el-button>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  props: {
    listId: {
      required: true
    }
  },

  methods: {
    importFile(event) {
      const formData = new FormData()
      formData.append('file', event.target.files[0])

      RestApi(
        projectEndpoint({
          method: 'post',
          url: `lists/${this.listId}/import`,
          config: { headers: { 'Content-Type': 'multipart/form-data' } },
          data: formData
        })
      )
        .then(({ data }) => {
          this.$router.push(
            projectRoute({
              name: 'TaskHistoryView',
              query: { id: data }
            })
          )
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/ListImportButton.vue